import styled, { keyframes } from 'styled-components';
import { IoIosArrowDown } from 'react-icons/io';

interface Props {
  time?: string;
  click?: boolean;
}

export const fadeInAnimation = keyframes`
from {
    opacity: 0
  }
  to {
    opacity: 1
  }
  `;

export const Separador = styled.div`
  height: auto;
  width: 17%;
  display: flex;
  flex-direction: column;
  color: #3c3c3b;
  font-size: 16px;
  text-align: center;
  opacity: 0;
  animation: ${fadeInAnimation} ${(props: Props) => props.time};
  animation-fill-mode: forwards;
  @media only screen and (max-width: 768px) {
    width: 30%;
    height: auto;
  }
`;

export const IconLinea = styled.img`
  width: 80%;
  @media only screen and (max-width: 768px) {
    width: 50%;
    height: 4rem;
    margin: 1rem;
    transform: rotate(90deg);
    -ms-transform: rotate(90deg); /* IE 9 */
    -webkit-transform: rotate(90deg); /* Opera, Chrome, and Safari */
  } ;
`;

const Rotate = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(180deg); }
`;

export const IconArrow = styled(IoIosArrowDown)`
  color: #3c3c3b;
  width: 2vw;
  height: 2vw;
  //transform: ${(props: Props) => props.click ? 'rotate(180deg)' : ' ' };
 // transition: all 0.6s linear;
 animation: ${Rotate} ${(props: Props) => props.click ? 'all 0.6s linear infinite' : ' ' } ;
  @media only screen and (max-width: 768px) {
    width: 4vw;
    height: 4vw;
  } ;
`;

export const SolapaMovil = styled.div`
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  color: #3c3c3b;
  font-size: 16px;
  opacity: ${props => (props.click ? "1" : "0")};
  max-height: ${props => (props.click ? "100%" : "0")};
  transition: all 0.6s linear;
// transform: ${(props: Props) => props.click ? 'translatey(200px)' :'0' }  ;
 // transition:all 0.5s linear ;
  @media only screen and (max-width: 768px) {
    height: auto;
  }
`;